import { render, staticRenderFns } from "./FolderDlg.vue?vue&type=template&id=e50b43d4&scoped=true"
import script from "./FolderDlg.vue?vue&type=script&lang=js"
export * from "./FolderDlg.vue?vue&type=script&lang=js"
import style0 from "./FolderDlg.vue?vue&type=style&index=0&id=e50b43d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e50b43d4",
  null
  
)

export default component.exports